import { Parm0Callback } from '@Components/app/members/teamInterfaces';
import { Events } from '@Context/common/general/context';
import Event from '@Helpers/event';
import { useEffect, useState } from 'react';

const WelcomeWizard = ({ 
    onComplete = () => {},
    config
} : {
    onComplete: Parm0Callback,
    config: string
}) => {

    const [ isWizardOpen, setIsWizardOpen ] = useState<boolean>(false);

    const handleWizardExit = () => {
        setIsWizardOpen(false);
        onComplete();
    }

    useEffect(() => {
        console.log("Mounting wizard controller");
        if( !isWizardOpen ) {
            console.log("Opening wizard");
            const onExit = new Event();
            onExit.on(handleWizardExit);
    
            const parms = {
                slidesConfigName: config,
                contexts: [],
                exitEvent: onExit,
            };
    
            setIsWizardOpen(true);
            Events.app.showWizardDialog.emit(parms);
        }

        // Important if component becomes unmounted because a notification condition changed (e.g. exclusive mode)
        return () => {
            console.log("Unmounting wizard controller");
            //if( isWizardOpen ) {
                console.log("Force closing wizard");
                setIsWizardOpen(false);
                Events.app.hideWizardDialog.emit();
                onComplete();
            //}
        };

    }, []);

    return (
    <></>
    )
}

export default WelcomeWizard;